import { createContext, type ReactNode, useContext, useMemo } from 'react';

export type EmbedRuntimeConfig = {
  allowedOrigins: string[];
  apiBaseUrl: string | null;
  reportTitle: string;
  scrubAccessTokenFromUrl: boolean;
  themeKey: string;
};

const defaultRuntimeConfig: EmbedRuntimeConfig = {
  allowedOrigins: [],
  apiBaseUrl: null,
  reportTitle: 'Embedded reports',
  scrubAccessTokenFromUrl: true,
  themeKey: 'default',
};

const EmbedRuntimeContext =
  createContext<EmbedRuntimeConfig>(defaultRuntimeConfig);

export function EmbedRuntimeProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: EmbedRuntimeConfig;
}) {
  const runtimeConfig = useMemo(() => value, [value]);

  return (
    <EmbedRuntimeContext.Provider value={runtimeConfig}>
      {children}
    </EmbedRuntimeContext.Provider>
  );
}

export function useEmbedRuntime() {
  return useContext(EmbedRuntimeContext);
}
